"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _touches = typeof window !== "undefined" && "ontouchstart" in window;

exports.default = function () {
  return _touches;
};
//# sourceMappingURL=useTouches.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/multi-slider/lib/useTouches.js
 ** module id = 102
 ** module chunks = 0
 **/